import React from "react";
import HomePricingCSS from "./HomePricing.module.scss";
import {Button} from "antd";
import {appRoutesConst} from "app/navigation";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router";
const HomePricingCard = (props) => {
  const {data} = props;
  const navigateTo = useNavigate();
  const dispatch = useDispatch();

  const _handleNavigation = (plan_id) => {
    dispatch({
      type: "SET_PLAN_DETAILS",
      payload: data,
    });
    navigateTo(`${appRoutesConst.signup}?plan_id=${plan_id}`);
  };
  console.log("keyyyy===>", props);
  return (
    <div className={`planmodalcard ${HomePricingCSS.PricingCard}`}>
      <div className={HomePricingCSS.PricingCard_heading}>
        <h4 className={HomePricingCSS.PricingCard_title}>{data.name}</h4>
        <p className={HomePricingCSS.PricingCard_desc}>{data.description}</p>
      </div>
      <div className={HomePricingCSS.PricingCard_price_wrapper}>
        <h4>£{data.price} </h4>
        <span>/month</span>
      </div>
      <div className={HomePricingCSS.PricingCard_plandesc}>
        <ul>
          {/* <li>
            Basic Virtual Light Bar Basic Virtual Light BarBasic Virtual Light
            Bar
          </li> */}
          <li>Video and EMDR</li>
          <li>EMDR Tools</li>
          <li>
            {props.labelKey === 0
              ? "5hrs per month of online sessions"
              : props.labelKey === 1
              ? "30hrs per month of online sessions"
              : "Unlimited online sessions"}
          </li>
          {props.labelKey !== 2 && <li>Email Support</li>}
          {props.labelKey === 2 && <li>Email & Phone Support</li>}
        </ul>
      </div>
      <div className={HomePricingCSS.PricingCard_button}>
        <Button
          type="primary"
          className="btn-primary btn medium-btn text-capitalize"
          onClick={() =>
            props.fromHeader
              ? props.handleCancelSubscription(data.id, "upgrade")
              : _handleNavigation(data.id)
          }
          // onClick={() => _handleNavigation(data.id)}
        >
          {props.fromHeader ? "Upgrade" : "Sign Up"}
        </Button>
      </div>
    </div>
  );
};

export default HomePricingCard;
